import {
  ADD_GUEST_PASS,
  REMOVE_GUEST_PASS,
  SET_CART_LOCATION,
  SET_CART_PRODUCT,
  SET_CART_PRODUCT_DEFAULT,
  SET_CART_DAYS,
  SET_CART_DATE,
  SET_CART_ACKNOWLEDGED_SOFT_CLOSE,
  RESET_CART_FORM
} from './actionTypes'

// cartForm:

export const addGuestPass = ({ camper, redeemablePass }) => {
  return {
    type: ADD_GUEST_PASS,
    camper,
    redeemablePass
  }
}

export const removeGuestPass = ({ camper, session, redeemablePass }) => {
  return {
    type: REMOVE_GUEST_PASS,
    camper,
    session,
    redeemablePass
  }
}

export const resetCartForm = ({ cart, campers, sessions }) => {
  return {
    type: RESET_CART_FORM,
    cart,
    campers,
    sessions
  }
}

export const setCartLocation = ({ camper, session, product, location }) => {
  return {
    type: SET_CART_LOCATION,
    camper,
    session,
    product,
    location
  }
}

export const setCartProduct = ({
  camper,
  session,
  camperSession,
  product,
  selectedType
}) => {
  return {
    type: SET_CART_PRODUCT,
    camper,
    session,
    camperSession,
    product,
    selectedType
  }
}

export const setCartProductDefault = ({
  camper,
  session,
  camperSession,
  product
}) => {
  return {
    type: SET_CART_PRODUCT_DEFAULT,
    camper,
    session,
    camperSession,
    product
  }
}

export const setCartDays = ({
  camper,
  session,
  camperSession,
  products,
  days
}) => {
  return {
    type: SET_CART_DAYS,
    camper,
    session,
    camperSession,
    products,
    days
  }
}

export const setCartDate = ({ camper, session, locationDay }) => {
  return {
    type: SET_CART_DATE,
    camper,
    session,
    locationDay
  }
}

export const setCartAcknowledgedSoftClose = ({
  camper,
  session,
  acknowledged
}) => {
  return {
    type: SET_CART_ACKNOWLEDGED_SOFT_CLOSE,
    camper,
    session,
    acknowledged
  }
}
